import axios from '../../axios'

export default {
	state: {
		status: '',
		token: sessionStorage.getItem('token') || localStorage.getItem('token') || '',
		role: sessionStorage.getItem('role') || localStorage.getItem('role') || '',
		user: {
			name: 'user Name'
		}
	},
	mutations: {
		auth_request (state) {
			state.status = 'loading'
		},
		auth_success (state, payload) {
			state.status = 'success'
			state.token = payload.token
			state.user = payload.user
			state.role = payload.role
		},
		auth_login_as (state, payload) {
			state.status = 'success'
			state.token = payload.token
			state.role = payload.role
		},
		auth_error (state) {
			state.status = 'error'
		},
		updateUserInfo (state, user) {
			state.user = user
		},
		logout (state) {
			state.status = ''
			state.token = ''
		}
	},
	actions: {
		updateUserInfo ({commit}, payload) {
			commit('updateUserInfo', payload)
		},
		login ({commit, dispatch}, payload) {
			return new Promise((resolve, reject) => {
				commit('auth_request')
				axios.post(payload.route, payload.payload)
					.then(resp => {
						const token = resp.data.data.token;
						const role = resp.data.data.role;
						dispatch('changeLayout', role.charAt(0).toUpperCase() + role.slice(1))

						localStorage.setItem('token', token)
						localStorage.setItem('role', role)
						dispatch('changeLayout', resp.data.data.role)
						axios.defaults.headers.common['Authorization'] = 'Bearer ' + token

						commit('auth_success', {
							token,
							user: payload.payload,
							role
						})
						resolve(resp)
					})
					.catch(err => {
						commit('auth_error')
						localStorage.removeItem('token')
						reject(err)
					})
			})
		},
		register ({commit, dispatch}, user) {
			return new Promise(async (resolve, reject) => {
				commit('auth_request')

				let route = user.url !== '/register'
					? '/author/auth/signup'
					: '/client/auth/signup';

				await axios.post(route, user.formData)
					.then(async resp => {
						if (resp.data.status === 422) {
							throw new Error(resp.data.message)
						}

						const token = resp.data.data.token;
						const role = resp.data.data.role;
						dispatch('changeLayout', role.charAt(0).toUpperCase() + role.slice(1));

						localStorage.setItem('token', token)
						localStorage.setItem('role', role)
						axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

						commit('auth_success', {
							token,
							user,
							role
						});

						if(user.url !== "/register") {
							const formData = new FormData();
							formData.append("file", user.photo);
							const photo = (await axios.post("upload/one", formData)).data.data.url;

							const updateData = { ...user.formData, photo };
							await axios.post("/author/profile/update", updateData);
						}

						setTimeout(() => {
							resolve(resp.data);
						}, 200);
						// return resp.data;
					})
					.catch(err => {
						commit('auth_error', err)
						localStorage.removeItem('token')
						console.log(err);
						reject(err)
					});
			})
		},
		logout ({commit}) {
			return new Promise((resolve, reject) => {
				commit('logout')
				localStorage.removeItem('token')
				delete axios.defaults.headers.common['Authorization']
				resolve()
			})
		}
	},
	getters: {
		isLoggedIn: state => !!state.token,
		authStatus: state => state.status,
		isAdmin: state => state.role === 'admin',
		getRole: state =>state.role,
		getIsIntercomAvailable: state => !!state.token && state.user.email && (state.role === 'manager' || state.role === 'author'),
		getUser: state => state.user
	}
}
